export class AddressType {
  // #region Properties

  public AddressTypeID: number;
  public AddressType: string;
  public Descr: string;
  public DateCreated: Date;
  public DateChanged: Date;
  public BillingDefault: boolean;
  public MailingDefault: boolean;
  public Public: boolean;

  // #endregion

  public constructor() {
    this.initialize();
  }

  public initialize(): void {
    this.AddressTypeID = 0;
    this.AddressType = '';
    this.Descr = '';
    this.DateCreated = new Date();
    this.DateChanged = new Date();
    this.BillingDefault = false;
    this.MailingDefault = false;
    this.Public = false;
  }
}
